import {TableTheme} from '@dv5/domain'
import React, {FC} from 'react'
import {TABLE_THEME_COLORS, TABLE_THEME_LABELS} from './constants'

interface Props {
    prefix: string
    value: TableTheme
    onChange: (theme: TableTheme) => void
}

export const TableThemePicker: FC<Props> = ({prefix, value, onChange}) => {
    return (
        <div className={`${prefix}__theme-group`}>
            {Object.values(TableTheme).map((theme) => (
                <button
                    key={theme}
                    className={`${prefix}__theme-btn ${value === theme ? `${prefix}__theme-btn--active` : ''}`}
                    style={{backgroundColor: TABLE_THEME_COLORS[theme]}}
                    onMouseDown={(e) => {
                        e.preventDefault()
                        e.stopPropagation()
                        onChange(theme)
                    }}
                    aria-label={`Set table theme to ${TABLE_THEME_LABELS[theme]}`}
                    title={TABLE_THEME_LABELS[theme]}
                    type='button'
                />
            ))}
        </div>
    )
}
